export default {
	Getter: {
		GET_LIST_FAVOURITES: "getListOfFavourites",
		GET_CURRENT_FAVOURITE: "getCurrentFavourite",
		GET_CURRENT_REQUEST_MODEL: "getCurrentFavourites",
		GET_FAVOURITES_SERVICE: "getFavouritesService",

		// Property
		GET_LIST_PROPERTY_FAVOURITES: "getListPropertyFavourites",
		GET_CURRENT_PROPERTY_FAVOURITE: "getCurrentPropertyFavourite",
		GET_ORIGINAL_PROPERTY_FAVOURITE: "getOriginalPropertyFavourite",
		// Client
		GET_LIST_PERSON_FAVOURITES: "getListPersonFavourites",
		GET_CURRENT_PERSON_FAVOURITE: "getCurrentPersonFavourite",
		GET_ORIGINAL_PERSON_FAVOURITE: "getOriginalPersonFavourite",
		// Demand
		GET_LIST_DEMAND_FAVOURITES: "getListDemandFavourites",
		GET_CURRENT_DEMAND_FAVOURITE: "getCurrentDemandFavourite",
		GET_ORIGINAL_DEMAND_FAVOURITE: "getOriginalDemandFavourite",
		// Task
		GET_LIST_TASK_FAVOURITES: "getListTaskFavourites",
		GET_CURRENT_TASK_FAVOURITE: "getCurrentTaskFavourite",
		GET_ORIGINAL_TASK_FAVOURITE: "getOriginalTaskFavourite",
	},
	Mutation: {
		UPDATE_LIST_FAVOURITES: "setListOfFavourites",
		RESET_CURRENT_FAVOURITE: "resetCurrentFavourite",
		UPDATE_CURRENT_FAVOURITE: "setCurrentFavourite",
		UPDATE_CURRENT_REQUEST_MODEL: "setCurrentFavourites",
		UPDATE_DEFAULT_FAVOURITE: "updateDefaultFavourite",

		UPDATE_ORIGINAL_FAVOURITE: "getOriginalFavourite",

		// Property
		UPDATE_LIST_PROPERTY_FAVOURITES: "getListPropertyFavourites",
		// Client
		UPDATE_LIST_PERSON_FAVOURITES: "getListPersonFavourites",
		// Demand
		UPDATE_LIST_DEMAND_FAVOURITES: "getListDemandFavourites",
		// Task
		UPDATE_LIST_TASK_FAVOURITES: "getListTaskFavourites",
	},
	Action: {
		GET_LIST_FAVOURITES: "getListOfFavourites",
		GET_DETAIL_FAVOURITE: "getDetailFavourite",
		ADD_FAVOURITE: "addNewFavourite",
		UPDATE_FAVOURITE: "updateFavourite",
		DELETE_FAVOURITE: "deleteFavourite",
		UPDATE_DEFAULT_FAVOURITE: "updateDefaultFavourite",
		SET_DEFAULT_FAVOURITE: 'setDefaultFavourite'
	}
};
